import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import UserLayout from './layouts/UserLayout';
import FullLayout from './layouts/FullLayout';
import Dashboard from './pages/Dashboard';
import APIKeys from './pages/APIKeys';
import Bills from './pages/Bills';
import Usage from './pages/Usage';
import Recharge from './pages/Recharge';
import Affiliate from './pages/Affiliate';
import Feedback from './pages/Feedback';
import MerchantCenter from './pages/MerchantCenter';
import ModelSquare from './pages/ModelSquare';
import RefRedirect from './pages/RefRedirect';
import CampaignRedirect from './pages/CampaignRedirect';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Pricing from './pages/Pricing';
import PriceCompare from './pages/PriceCompare';
import Presets from './pages/Presets';
import Batches from './pages/Batches';
import Playground from './pages/Playground';
import CreativeInspiration from './pages/CreativeInspiration';
import W3Studio from './pages/W3Studio';
import AudioStudio from './pages/AudioStudio';
import LivenessCallback from './pages/LivenessCallback';
import { setPageTitle } from './utils/documentTitle';

// 页面标题映射
const pageTitles = {
  '/': 'home',
  '/login': 'Login',
  '/register': 'Register',
  '/dashboard': 'user_console',
  '/dashboard/apikeys': 'api_key_management',
  '/dashboard/bills': 'bill_management',
  '/dashboard/batches': 'batch_processing',
  '/dashboard/presets': 'preset_management',
  '/dashboard/models': 'model_square',
  '/dashboard/model-training': 'model_training',
  '/dashboard/recharge': 'top_up',
  '/dashboard/affiliate': 'merchant_center',
  '/dashboard/feedback': 'feedback_title',
  '/dashboard/merchant': 'merchant_title',
  '/dashboard/creative': 'creative_inspiration',
  '/dashboard/w3': 'w3_studio',
  '/dashboard/audio': 'audio_studio',
  '/compare': 'price_compare',
  '/about': 'About Us',
  '/contact': 'Contact Us',
  '/privacy': 'Privacy Policy',
  '/terms': 'Terms of Service',
  '/pricing': 'Pricing',
};

function App() {
  const token = localStorage.getItem('user_token');
  const location = useLocation();

  // 监听路由变化，动态设置页面标题
  useEffect(() => {
    const path = location.pathname;
    // 匹配dashboard子路由
    if (path.startsWith('/dashboard')) {
      const matchedTitle = pageTitles[path] || pageTitles['/dashboard'];
      setPageTitle(matchedTitle);
    } else {
      const matchedTitle = pageTitles[path] || 'Blue API';
      if (matchedTitle.includes('_')) {
        setPageTitle(matchedTitle);
      } else {
        document.title = `Blue API - ${matchedTitle}`;
      }
    }
  }, [location]);

  return (
    <Routes>
      {/* 官网首页 */}
      <Route path="/" element={<Landing />} />

      {/* 短链接 - 邀请码重定向（商户/代理商邀请） */}
      <Route path="/r/:code" element={<RefRedirect />} />

      {/* 短链接 - 活动链接重定向（平台活动） */}
      <Route path="/c/:code" element={<CampaignRedirect />} />

      {/* 短链接 - 商户中心 */}
      <Route path="/m" element={token ? <Navigate to="/dashboard/merchant" /> : <Navigate to="/login" />} />

      {/* 登录注册 */}
      <Route path="/login" element={token ? <Navigate to="/dashboard" /> : <Login />} />
      <Route path="/register" element={<Register />} />

      {/* 公司信息页面 */}
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/liveness-callback" element={<LivenessCallback />} />

      {/* 模型广场 - 全屏布局 (无 Header) */}
      <Route
        path="/dashboard/models"
        element={token ? <FullLayout /> : <Navigate to="/login" />}
      >
        <Route index element={<ModelSquare />} />
      </Route>

      {/* 价格对比 - 独立路由 */}
      <Route
        path="/compare"
        element={token ? <FullLayout /> : <Navigate to="/login" />}
      >
        <Route index element={<PriceCompare />} />
      </Route>

      {/* 用户后台 */}
      <Route
        path="/dashboard"
        element={token ? <UserLayout /> : <Navigate to="/login" />}
      >
        <Route index element={<Dashboard />} />
        <Route path="apikeys" element={<APIKeys />} />
        <Route path="bills" element={<Bills />} />
        <Route path="usage" element={<Usage />} />
        <Route path="batches" element={<Batches />} />
        <Route path="presets" element={<Presets />} />
        <Route path="model-training" element={<Playground />} />
        <Route path="recharge" element={<Recharge />} />
        <Route path="affiliate" element={<Affiliate />} />
        <Route path="feedback" element={<Feedback />} />
        <Route path="merchant" element={<MerchantCenter />} />
        <Route path="creative" element={<CreativeInspiration />} />
        <Route path="w3" element={<W3Studio />} />
        <Route path="audio" element={<AudioStudio />} />
      </Route>
    </Routes>
  );
}

export default App;
